module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    温馨提醒：为正确显示本网站，请使用\n    "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "http://browser.qq.com/",
      "target": "_blank"
    }
  }, [_vm._v("QQ浏览器(极速模式)、")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "http://browser.360.cn/",
      "target": "_blank"
    }
  }, [_vm._v("360浏览器(极速模式)、")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://www.google.cn/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("谷歌浏览器、")]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://support.microsoft.com/zh-cn/topic/%E4%B8%8B%E8%BD%BD-internet-explorer-11-%E8%84%B1%E6%9C%BA%E5%AE%89%E8%A3%85%E7%A8%8B%E5%BA%8F-99d492a1-3a62-077b-c476-cf028aff9a7f",
      "target": "_blank"
    }
  }, [_vm._v("微软IE 11、")])]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "https://www.microsoft.com/zh-cn/edge",
      "target": "_blank"
    }
  }, [_vm._v("微软Edge、")])]), _vm._v(" "), _c('span', [_c('a', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "href": "http://www.firefox.com.cn/",
      "target": "_blank"
    }
  }, [_vm._v("火狐浏览器 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5d5fb3a8!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/versionReminder.vue
// module id = 298
// module chunks = 0